import { render, staticRenderFns } from "./h30.vue?vue&type=template&id=964a23de&scoped=true&"
import script from "./h30.vue?vue&type=script&lang=js&"
export * from "./h30.vue?vue&type=script&lang=js&"
import style0 from "./h30.vue?vue&type=style&index=0&id=964a23de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a23de",
  null
  
)

export default component.exports